import React from 'react';
import PropTypes from 'prop-types';
import {
  PAPER_TABS,
  Spacing_Base,
  FontSize_Css_Plus,
} from '../../../data/common';
import { strParse } from '../../../lib/util';

function MTypeTestRow({ vocaList = {}, startNo, tab, config }) {
  // console.log('vocabList M:', vocaList);
  return (
    <div
      style={{
        width: '100%',
        marginTop: `${config?.spacing * Spacing_Base}px`,
      }}
    >
      {tab !== PAPER_TABS.ANSWER && (
        <div
          style={{
            fontSize: `${config?.fontSize + FontSize_Css_Plus}px`,
            fontWeight: 700,
            fontFamily: "'Pretendard', Arial, sans-serif",
          }}
        >
          ※&nbsp;{vocaList?.title}
        </div>
      )}
      <div>
        {vocaList?.questions
          ?.filter(voca => voca?.options?.length === 4)
          ?.map((voca, idx) => {
            return (
              <div
                key={`${voca.questions}-${String(idx)}`}
                style={{
                  marginTop: `${config?.spacing * Spacing_Base}px`,
                  fontSize: `${config?.fontSize + FontSize_Css_Plus}px`,
                  display: 'grid',
                  gridTemplateColumns: '1.2fr 8.8fr',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  gap: '5px',
                  fontFamily: "'Pretendard', Arial, sans-serif",
                  width: '100%',
                }}
              >
                <div
                  style={{
                    flexShrink: 0,
                    minWidth: '10px',
                    fontFamily: "'Pretendard', Arial, sans-serif",
                  }}
                >
                  {startNo + idx}.
                </div>
                {(tab === PAPER_TABS.TEST_PAPER ||
                  tab === PAPER_TABS.ANSWER_TEST_PAPER) && (
                  <div
                    style={{ fontFamily: "'Pretendard', Arial, sans-serif" }}
                  >
                    <div
                      style={{
                        fontFamily: "'Pretendard', Arial, sans-serif",
                        marginBottom: '5px',
                      }}
                    >
                      {strParse(voca.question)}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        gap: '5px',
                      }}
                    >
                      {voca.options.map((option, idx) => {
                        return (
                          <div
                            key={`${option}-${String(idx)}`}
                            style={{
                              display: 'flex',
                              justifyContent: 'flex-start',
                              alignItems: 'center',
                              gap: '5px',
                            }}
                          >
                            <div
                              style={{
                                width: `${config?.fontSize}px`,
                                height: `${config?.fontSize}px`,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontSize: `${config?.fontSize - 2}px`,
                                fontFamily: "'Pretendard', Arial, sans-serif",
                                border: '1px solid black',
                                borderRadius: '50%',
                                padding: 0,
                                flexShrink: 0,
                              }}
                            >
                              {idx + 1}
                            </div>
                            <div
                              style={{
                                fontSize: `${config?.fontSize + FontSize_Css_Plus}px`,
                                fontFamily: "'Pretendard', Arial, sans-serif",
                                fontWeight:
                                  tab === PAPER_TABS.ANSWER_TEST_PAPER &&
                                  voca.answer === idx + 1
                                    ? 700
                                    : 400,
                                textDecoration:
                                  tab === PAPER_TABS.ANSWER_TEST_PAPER &&
                                  voca.answer === idx + 1
                                    ? 'underline'
                                    : 'none',
                                // borderBottom:
                                //   tab === PAPER_TABS.ANSWER_TEST_PAPER &&
                                //   voca.answer === idx + 1
                                //     ? '1px solid black'
                                //     : 'none',
                              }}
                            >
                              {option}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
                {tab === PAPER_TABS.ANSWER && (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      paddingTop: '2px',
                    }}
                  >
                    <div
                      style={{
                        width: `${config?.fontSize}px`,
                        height: `${config?.fontSize}px`,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: `${config?.fontSize - 2}px`,
                        fontFamily: "'Pretendard', Arial, sans-serif",
                        border: '1px solid black',
                        borderRadius: '50%',
                        padding: 0,
                      }}
                    >
                      {voca.answer}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
}

MTypeTestRow.propTypes = {
  vocaList: PropTypes.object,
  startNo: PropTypes.number,
  tab: PropTypes.string.isRequired,
  config: PropTypes.object,
};

export default MTypeTestRow;
